import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
  onCreateNews,
  onDeleteNews,
  onGetNews,
  onGetPagedAllNews,
  onUpdateNews,
  // onGetNewsTypes,
} from '../../../app/modules/news/components/news-creation/core/_requests'
import {onGetNewsTypes} from '../../../app/services/dataForComboBox/dataForComboBoxService'
//import {onGetNewsTypes} from '../../../app/services/dataForComboBox/dataForComboBoxService'
interface NewsState {
  allNews: any
  news: any
  newsTypes: any
  isLoading: boolean
}
const initialState = {
  allNews: [],
  news: null,
  newsTypes: [],
  isLoading: true,
} as NewsState

export const fetchNewsTypes = createAsyncThunk('news/fetchNewsTypes', async () => {
  const data: any = await onGetNewsTypes()
  return data.data.result.items
})

export const fetchAllNews = createAsyncThunk('news/fetchAllNews', async (param: any) => {
  const data: any = await onGetPagedAllNews(param)
  return data.data.result
})

export const fetchNews = createAsyncThunk('news/fetchNews', async (param: any) => {
  const data: any = await onGetNews(param)
  return data.data.result
})

export const updateNews = createAsyncThunk('news/updateNews', async (param: any) => {
  const data: any = await onUpdateNews(param)
  return data.data
})

export const createNews = createAsyncThunk('news/createNews', async (param: any) => {
  const data: any = await onCreateNews(param)
  return data.data
})

export const deleteNews = createAsyncThunk('news/deleteNews', async (param: any) => {
  const data: any = await onDeleteNews(param)
  return data.data
})

const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    clearAllNews: (state) => {
      state.allNews = []
    },
    clearNews: (state) => {
      state.news = null
    },
    activateLoading: (state) => {
      state.isLoading = true
    },
    clearAllFilters: (state) => {
      state.allNews = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllNews.pending, (state: any) => {
      state.isLoading = true
    })
    builder.addCase(fetchAllNews.fulfilled, (state: any, action) => {
      state.allNews = action.payload
      state.isLoading = false
    })
    builder.addCase(fetchAllNews.rejected, (state: any) => {
      state.isLoading = false
    })
    builder.addCase(fetchNews.fulfilled, (state: any, action) => {
      state.news = action.payload
    })
    builder.addCase(fetchNewsTypes.fulfilled, (state: any, action) => {
      state.newsTypes = action.payload
    })
  },
})

export const {clearAllNews, clearNews, activateLoading} = newsSlice.actions

export default newsSlice.reducer
